"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reduxForm = require("redux-form");

var _reactIntl = require("react-intl");

var _reactRedux = require("react-redux");

var _BedInput = require("../../forms/BedInput");

var _BedInput2 = _interopRequireDefault(_BedInput);

var _FieldSet = require("../../forms/FieldSet");

var _FieldSet2 = _interopRequireDefault(_FieldSet);

var _FormErrorMessage = require("../../forms/FormErrorMessage");

var _FormErrorMessage2 = _interopRequireDefault(_FormErrorMessage);

var _FormHeaderText = require("../../forms/FormHeaderText");

var _FormHeaderText2 = _interopRequireDefault(_FormHeaderText);

var _FormInstructionalText = require("../../forms/FormInstructionalText");

var _FormInstructionalText2 = _interopRequireDefault(_FormInstructionalText);

var _FormStubText = require("../../forms/FormStubText");

var _FormStubText2 = _interopRequireDefault(_FormStubText);

var _FormSubmit = require("../../forms/FormSubmit");

var _FormSubmit2 = _interopRequireDefault(_FormSubmit);

var _PaxSelect = require("../../forms/PaxSelect");

var _PaxSelect2 = _interopRequireDefault(_PaxSelect);

var _RoomingReasonText = require("../../forms/RoomingReasonText");

var _RoomingReasonText2 = _interopRequireDefault(_RoomingReasonText);

var _StatusInput = require("../../forms/StatusInput");

var _StatusInput2 = _interopRequireDefault(_StatusInput);

var _forms = require("../../../utils/forms");

var _pacomo = require("../../../utils/pacomo");

var _forms2 = require("../../../metadata/forms");

var _lodash = require("lodash");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Metadata


// Utils


// Components
var RoomingInformationBase = function RoomingInformationBase(_ref) {
    var intl = _ref.intl,
        hiddenValues = _ref.hiddenValues,
        requirementsByCode = _ref.requirementsByCode,
        departureServicesById = _ref.departureServicesById,
        isFetchingRequirementData = _ref.isFetchingRequirementData,
        handleSubmit = _ref.handleSubmit,
        error = _ref.error,
        invalid = _ref.invalid,
        pristine = _ref.pristine,
        submitSucceeded = _ref.submitSucceeded,
        submitFailed = _ref.submitFailed,
        submitting = _ref.submitting,
        bookingId = _ref.bookingId,
        initialValues = _ref.initialValues,
        bookingCompanyId = _ref.bookingCompanyId,
        formValues = _ref.formValues;

    /**
     * Adding "context" to the requirementsByCode object for value access visibility.
     *
     * @param {{ ROOMING_DETAILS: {}, ROOMING_MULTISHARE_ACKNOWLEDGEMENT: {} }} requirementsByCode
     */
    var roomingDetails = requirementsByCode.ROOMING_DETAILS ? requirementsByCode.ROOMING_DETAILS : [];

    var isApproved = function isApproved(approvedBy) {
        if (!approvedBy || !approvedBy.value) return false;
        if (approvedBy.value && approvedBy.value === "Unknown") {
            return false;
        }
        return !!(approvedBy.value && Array.isArray(approvedBy.value));
    };

    var requirements = roomingDetails.map(function (req, i) {
        var valuePath = (0, _forms.generateValuePath)({
            requirement: req,
            resourceType: "rooming_requests"
        });
        var departureService = departureServicesById[req.services[0].id];
        var reqReason = (0, _forms.getReqField)(req, "reason");
        var shareStyle = (0, _forms.getReqField)(req, "share_style");
        var approvedBy = (0, _forms.getReqField)(req, "approved_by");
        var excludedCustomers = _lodash2.default.get(formValues, valuePath + ".excluded_customers", []);

        return _react2.default.createElement(
            "div",
            { className: "tourWrapper", key: i },
            departureService && _react2.default.createElement(_FormHeaderText2.default, {
                instructionalText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "formRoomingDetails.tourName",
                    defaultMessage: "Tour: {tourName}",
                    values: {
                        tourName: departureService.name
                    }
                })
            }),
            !isApproved(approvedBy) && _react2.default.createElement(_FieldSet2.default, {
                requirement: req,
                fields: [{
                    id: "status",
                    label: "Approval Required",
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: "status",
                        name: valuePath + ".approved_by",
                        hiddenValues: hiddenValues,
                        component: _StatusInput2.default,
                        requirement: req,
                        helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: "RoomingInformation.approvedByHelp",
                            defaultMessage: "Someone may have wanted to request a room with you. If you recognize their name and know who they are, you can agree to the request by selecting the Approve box and clicking Save at the bottom."
                        })
                    })
                }]
            }),
            _react2.default.createElement(_FieldSet2.default, {
                requirement: req,
                fields: [{
                    id: "customers",
                    label: "Select Rooming Companion",
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: "customers",
                        name: valuePath + ".customers",
                        hiddenValues: hiddenValues,
                        component: _PaxSelect2.default,
                        requirement: req,
                        helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: "RoomingInformation.customers",
                            defaultMessage: "Select the traveller(s) you would like to be rooming with at twin-share accommodations on your trip."
                        }),
                        bookingCompanyId: bookingCompanyId,
                        excludedCustomers: excludedCustomers
                    })
                }, {
                    id: "bed_type",
                    label: "Bed Type",
                    field: _react2.default.createElement(_reduxForm.Field, {
                        id: "bed_type",
                        name: valuePath + ".bed_type",
                        hiddenValues: hiddenValues,
                        component: _BedInput2.default,
                        requirement: req,
                        helpText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                            id: "RoomingInformation.bed_Type",
                            defaultMessage: "Select the type of bed you want in your room."
                        })
                    })
                }]
            }),
            reqReason && reqReason.value && _react2.default.createElement(_RoomingReasonText2.default, { code: reqReason.value }),
            shareStyle && shareStyle.value === "PARTIAL_MULTISHARE" && _react2.default.createElement(_FormInstructionalText2.default, {
                instructionalText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "RoomingInformation.multishare_note",
                    defaultMessage: "Please note: On the tour that you have selected,\n                                there are nights that use multi-share accommodation. On these\n                                nights, you will be sharing with other travellers of the same\n                                gender in dorm style accommodation."
                })
            }),
            shareStyle && shareStyle !== "FULL_MULTISHARE" && _react2.default.createElement(_FormInstructionalText2.default, {
                instructionalText: _react2.default.createElement(_reactIntl.FormattedMessage, {
                    id: "roomingInformation.tourInstructions",
                    defaultMessage: "While we will try to ensure that your\n                                preferences are respected, please understand that we cannot\n                                always guarantee your preferred rooming configuration."
                })
            })
        );
    });

    return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
            "form",
            null,
            _react2.default.createElement(
                _FormErrorMessage2.default,
                {
                    errorCode: error,
                    invalid: invalid,
                    submitFailed: submitFailed,
                    submitting: submitting
                },
                error && "Roommate unavailable, please select a different roommate or contact support."
            ),
            roomingDetails && requirements && requirements,
            requirementsByCode.ROOMING_MULTISHARE_ACKNOWLEDGEMENT && _react2.default.createElement(
                "div",
                { className: "override" },
                _react2.default.createElement(_FormStubText2.default, {
                    stubText: "I acknowledge that this trip uses multi-share accommodation throughout, and I will be roomed with other travellers of the same gender"
                }),
                _react2.default.createElement(_FieldSet2.default, {
                    requirement: requirementsByCode.ROOMING_MULTISHARE_ACKNOWLEDGEMENT,
                    fields: [(0, _extends3.default)({}, (0, _forms.generateOverride)({
                        intl: intl,
                        id: "roomingMultishareAcknowledgement",
                        requirement: requirementsByCode.ROOMING_MULTISHARE_ACKNOWLEDGEMENT,
                        overrideLabels: _forms2.formOverrides.acknowledgements,
                        bookingId: bookingId,
                        initialValues: initialValues
                    }))]
                })
            ),
            _react2.default.createElement(_FormSubmit2.default, {
                handleSubmit: handleSubmit,
                pristine: pristine,
                submitting: submitting,
                submitFailed: submitFailed,
                submitSucceeded: submitSucceeded,
                isFetchingRequirementData: isFetchingRequirementData
            })
        )
    );
}; // React & libraries


RoomingInformationBase.propTypes = {
    intl: _propTypes2.default.object.isRequired,
    initialValues: _propTypes2.default.object.isRequired,
    hiddenValues: _propTypes2.default.object.isRequired,
    requirementsByCode: _propTypes2.default.object.isRequired,
    isFetchingRequirementData: _propTypes2.default.bool.isRequired,
    handleSubmit: _propTypes2.default.func.isRequired,
    error: _propTypes2.default.string,
    invalid: _propTypes2.default.bool,
    pristine: _propTypes2.default.bool,
    submitting: _propTypes2.default.bool,
    submitSucceeded: _propTypes2.default.bool,
    submitFailed: _propTypes2.default.bool,
    formValues: _propTypes2.default.object
};

RoomingInformationBase.displayName = 'RoomingInformation';
var RoomingInformation = (0, _pacomo.pacomoTransformer)(RoomingInformationBase);

var RoomingInformationForm = (0, _reduxForm.reduxForm)({
    form: "RoomingInformation",
    enableReinitialize: true,
    onSubmitFail: function onSubmitFail(errors, dispatch, submitError, props) {
        var roomingDetails = props.requirementsByCode.ROOMING_DETAILS || [];

        roomingDetails.forEach(function (req) {
            var valuePath = (0, _forms.generateValuePath)({
                requirement: req,
                resourceType: "rooming_requests"
            });

            var currentCustomers = _lodash2.default.get(props.formValues, valuePath + ".customers", []);
            props.change(valuePath + ".excluded_customers", currentCustomers.map(function (customer) {
                return customer.id;
            }));
            props.change(valuePath + ".customers", []);
        });
    }
})(RoomingInformation);

exports.default = (0, _reactRedux.connect)(function (state) {
    return {
        formValues: _lodash2.default.get(state, "form.RoomingInformation.values", {})
    };
})((0, _reactIntl.injectIntl)(RoomingInformationForm));
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ./app/components/RequirementSet/forms/RoomingInformation.js
// module id = 1326
// module chunks = 0